import gql from 'graphql-tag'

export const initDayStatistics = gql`
	query initDayStatistics($params: StatisticsDayParams!) {
		cashAssist {
			initDayStatistics(params: $params)
		}
	}
`

export const getStatisticsData = gql`
	query getStatisticsData($requestId: ID!) {
		cashAssist {
			getStatisticsData(requestId: $requestId) {
				status
				progress
				hasNextPage
				data {
					... on StatisticDay {
						IntervalField
						Product
						Shop
						Total
						PriceByOne
						Amount
						Netto
					}
				}
			}
		}
	}
`
